import { TFunction } from 'react-i18next';
import {
  BelowThresholdActionOption,
  MergeFieldValidationOption,
} from './types';
import {
  BELOW_THRESHOLD_ACTION_OPTIONS,
  MERGE_FIELD_VALIDATION_OPTIONS,
} from './constants';

export const getMergeFieldValidationOptions = (
  t: TFunction
): MergeFieldValidationOption[] => [
  {
    value: MERGE_FIELD_VALIDATION_OPTIONS.error_if_required,
    label: t('Error if any merge field is blank'),
  },
  {
    value: MERGE_FIELD_VALIDATION_OPTIONS.default_to_unknown,
    label: t("Default to 'Unknown'"),
  },
  {
    value: MERGE_FIELD_VALIDATION_OPTIONS.blank,
    label: t('Leave Blank'),
  },
];

export const getBelowThresholdActionOptions = (
  t: TFunction
): BelowThresholdActionOption[] => [
  {
    value: BELOW_THRESHOLD_ACTION_OPTIONS.continue_down_yes_path,
    label: t('Continue down yes path'),
  },
  {
    value: BELOW_THRESHOLD_ACTION_OPTIONS.continue_down_no_path,
    label: t('Continue down no path'),
  },
  {
    value: BELOW_THRESHOLD_ACTION_OPTIONS.fail_the_step,
    label: t('Fail the step'),
  },
];
export const optionsFlatMapper = (groupedOptions: { options: any[] }[]) =>
  groupedOptions.flatMap(({ options }) => options);
